module.exports = __webpack_public_path__ + "media/images/summary-5d9312f606704374789bc035497e4e35.png";